import { defineSlotRecipe } from '@chakra-ui/react';

const Tabs = defineSlotRecipe({
  slots: ['root', 'list', 'trigger', 'content', 'indicator'],
  base: {
    trigger: {
      height: '100%',
    },
  },

  defaultVariants: {
    // @ts-ignore: 'variant' is a valid key here in docs
    variant: 'outline',
  },
});

export default Tabs;
